import { Injectable, Renderer2, RendererFactory2 } from '@angular/core';

@Injectable()
export class StylesService {
  private renderer: Renderer2;

  constructor(private rendererFactory: RendererFactory2) {
    this.renderer = rendererFactory.createRenderer(null, null);
  }

  setGlobalStyles(theme: string): void {
    // Remove existing stylesheet
    const existingStylesheet = document.getElementById('globalStylesheet');
    if (existingStylesheet) {
      existingStylesheet.parentNode.removeChild(existingStylesheet);
    }

    // Create a new link element for the stylesheet
    const linkElement = this.renderer.createElement('link');
    this.renderer.setAttribute(linkElement, 'id', 'globalStylesheet');
    this.renderer.setAttribute(linkElement, 'rel', 'stylesheet');
    this.renderer.setAttribute(linkElement, 'type', 'text/css');
    this.renderer.setAttribute(linkElement, 'href', `assets/styles/style-${theme}.css`);

    // Append the new stylesheet to the head
    this.renderer.appendChild(document.head, linkElement);
  }
}



// WEBPACK FOOTER //
// /app/src/app/services/styles.service.ts